import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { IoArrowBackSharp } from "react-icons/io5";
import { useFormik } from "formik";
import * as Yup from "yup";
import "./expenseMangementFormStyle.css";
import CustomAutoCompleteDropdown from "../../../../components/custom_auto_complete_dropdown/CustomAutoCompleteDropdown";
import CustomTextField from "../../../../components/custom_text_field/CustomTextField";
import CustomTextArea from "../../../../components/custom_text_area/CustomTextArea";
import { get_status } from "../../../../api/statusApis";
import { ErrorToast, InfoToast, SuccessToast } from "../../../../toast/toasts";
import { LiaExchangeAltSolid } from "react-icons/lia";
import { get_expense_head } from "../../../../api/expenseHeadApis";
import { create_expense, get_expense_by_id, update_expense, update_expense_document } from "../../../../api/expenseManagementApis";
function ExpenseManagementForm() {
  const navigate = useNavigate();
  const location = useLocation()
  const [isPreviousDate, setIsPreviousDate] = useState(false)
  const { expense_id } = useParams();
  const today = new Date();

  const monthName = today.toLocaleString('default', { month: 'long' });
  const monthNumber = String(today.getMonth() + 1).padStart(2, '0');
  const year = today.getFullYear();

  const prevMonthDate = new Date(year, today.getMonth() - 1, 1);
  const prevMonthNumber = String(prevMonthDate.getMonth() + 1).padStart(2, '0');
  const prevMonthName = prevMonthDate.toLocaleString('default', { month: 'long' });
  const prevYear = prevMonthDate.getFullYear();


  const [expenseHeadOptions, setExpenseHeadOptions] = useState([]);
  const [attachments, setAttachments] = useState([]); // for uploaded files
  const [isView, setIsView] = useState(null)
  const [existsAttachmentDelete, setExistsAttachmentDelete] = useState([])
  // useEffect(() => {
  //   if (location.pathname.split('/').pop() === "view_expense") {
  //     setIsView(true)
  //   }
  //   fetchExpenseHeadList();
  //   if (expense_id) {
  //     get_expense_by_id(expense_id).then(response => {
  //       const data = response?.data?.data;
  //       console.log(data)
  //       formik.setValues({
  //         expense_head: data?.expense_head_id,
  //         amount: data?.amount,
  //         remark: data?.description || "",
  //         month_year: data?.month_year
  //       });
  //       setAttachments(data?.documents || [])
  //     });
  //   }
  // }, [expense_id]);

  const fetchExpenseHeadList = () => {
    get_expense_head({ status: 1 }).then((response) => {
      const data = response.data.data.data
      console.log(data)
      const options = data.map((item) => ({
        label: item.ExpenseName,
        value: item.expense_head_id,
      }));
      setExpenseHeadOptions(options);
    }).catch((error) => {
      console.log(error)
    })
  };

  const formik = useFormik({
    initialValues: {
      expense_head: "",
      amount: "",
      remark: "",
      month_year: ""
    },
    validationSchema: Yup.object({
      expense_head: Yup.string().required("Expense head is required"),
      amount: Yup.number()
        .typeError("Amount must be a number")
        .required("Amount is required")
        .positive("Amount must be greater than zero"),
      // remark: Yup.string().required("Remark is required"),
    }),
    onSubmit: (values) => {
      const formData = new FormData();
      const fileAttachmentFormData = new FormData();


      // Basic fields
      formData.append("expense_head_id", values?.expense_head);
      formData.append("description", values?.remark);
      formData.append("amount", values?.amount);
      formData.append(
        "month_year",
        expense_id
          ? values?.month_year
          : values?.month_year
      );
      // formData.append(
      //   "month_year",
      //   expense_id
      //     ? values?.month_year
      //     : isPreviousDate
      //       ? `${prevYear}-${prevMonthNumber}`
      //       : `${year}-${monthNumber}`
      // );

      if (!expense_id) {
        // Create new expense
        attachments.forEach((file) => {
          formData.append("documents[]", file);
        });
      } else {
        // Update existing expense
        formData.append("expense_history_id", expense_id);
        fileAttachmentFormData.append("expense_history_id", expense_id);

        const newFiles = attachments.filter((item) => !item?.expense_history_id);
        const deletedFiles = existsAttachmentDelete || [];

        // Only append if any new files
        if (newFiles.length > 0) {
          newFiles.forEach((file) => {
            fileAttachmentFormData.append("documents[]", file);
          });
        }

        // Only append if any files to remove
        if (deletedFiles.length > 0) {
          fileAttachmentFormData.append("documents_to_remove", JSON.stringify(deletedFiles));
          // deletedFiles.forEach((item) => {
          //   fileAttachmentFormData.append("documents_to_remove[]", item);
          // });
        }
      }

      // Main expense API call
      const apiCall = expense_id ? update_expense(formData) : create_expense(formData);

      apiCall
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            if (expense_id) {
              // Only call update_expense_document if attachments actually changed
              if ([...fileAttachmentFormData.entries()].length > 1) {
                update_expense_document(fileAttachmentFormData)
                  .then(() => {
                    SuccessToast("Expense updated");
                    navigate(-1);
                  })
                  .catch(() => {
                    ErrorToast("Expense updated, but document update failed");
                  });
              } else {
                SuccessToast("Expense updated");
                navigate(-1);
              }
            } else {
              SuccessToast("Expense added");
              navigate(-1);
            }
          }
        })
        .catch((error) => {
          let message = "An error occurred.";
          if (error?.data?.errors) {
            message = Object.values(error.data.errors).flat().join(" ");
          }
          ErrorToast(message);
        });
    },

  });

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setAttachments((prev) => [...prev, ...files]);
  };

  const handleRemoveFile = (index, exists_id) => {
    setAttachments((prev) => prev.filter((_, i) => i !== index));
    if (exists_id) {
      setExistsAttachmentDelete((prev) => [...prev, exists_id])
    }
  };

  const handleReset = () => {
    formik.resetForm();
    setAttachments([]);
    formik.setFieldValue("month_year", `${year}-${monthNumber}`);
  };


  // Dropdown options for month-year
  const monthYearOptions = [
    { label: `${monthName} ${year}`, value: `${year}-${monthNumber}` },
    { label: `${prevMonthName} ${prevYear}`, value: `${prevYear}-${prevMonthNumber}` },
  ];
  useEffect(() => {
    if (location.pathname.split("/").pop() === "view_expense") {
      setIsView(true);
    }
    fetchExpenseHeadList();

    if (expense_id) {
      get_expense_by_id(expense_id).then((response) => {
        const data = response?.data?.data;
        formik.setValues({
          expense_head: data?.expense_head_id,
          amount: data?.amount,
          remark: data?.description || "",
          month_year: data?.month_year,
        });
        setAttachments(data?.documents || []);
      });
    } else {
      // Set default month_year if adding new expense
      formik.setFieldValue("month_year", `${year}-${monthNumber}`);
    }
  }, [expense_id]);

  /** Handle Month Dropdown Change */
  const handleMonthChange = (event, newValue) => {
    formik.setFieldValue(
      "month_year",
      newValue ? newValue.value : `${year}-${monthNumber}`
    );
  };

  return (
    <div className="expense_management_form_super_container">
      <div className="expense_management_form_sub_container">
        <div className="expense_management_form_single_row_alignment">
          <IoArrowBackSharp
            className="expense_management_form_back"
            onClick={() => navigate(-1)}
          />
         <div className="expense_management_form_title_block">
             <p className="expense_management_form_title">
              {isView
                ? "View Expense"
                : expense_id
                  ? "Update Expense"
                  : "Add New Expense"}
            </p>
            <CustomAutoCompleteDropdown
              isDisabled={isView}
              name="month_year"
              placeholder="Select month"
              options={monthYearOptions}
              onChange={handleMonthChange}
              onBlur={formik.handleBlur}
              value={
                monthYearOptions.find(
                  (opt) => opt.value === formik.values.month_year
                ) || null
              }
              error={formik.touched.month_year && Boolean(formik.errors.month_year)}
              helperText={formik.touched.month_year && formik.errors.month_year}
            />
          </div>

          {/* <p className="expense_management_form_title">
            {isView
              ? `View Expense - (${formik?.values?.month_year
                ? new Date(`${formik.values.month_year}-01`).toLocaleString('default', {
                  month: 'long',
                  year: 'numeric',
                })
                : ''})`
              : expense_id
                ? `Update Expense - (${formik?.values?.month_year
                  ? new Date(`${formik.values.month_year}-01`).toLocaleString('default', {
                    month: 'long',
                    year: 'numeric',
                  })
                  : ''})`
                : `Add New Expense - (${isPreviousDate
                  ? `${prevMonthName} ${prevYear}`
                  : `${monthName} ${year}`
                })`}
          </p> */}
          {/* {!expense_id && (
            <div className="expense_management_icon-button" onClick={() => {
              if (!isPreviousDate) {
                InfoToast("You have chosen the previous month and year")
              }
              setIsPreviousDate(!isPreviousDate)
            }}>
              <LiaExchangeAltSolid size={20} />
            </div>
          )} */}

        </div>
        {!isView && (
          <div className="expense_management_form_single_row_alignment">
            {!expense_id && (
              <button
                className="expense_management_form_reset_button"
                type="button"
                onClick={handleReset}
              >
                Reset
              </button>
            )}
            <button
              className="expense_management_form_save_button"
              type="submit"
              form="expenseform"
            >
              Save
            </button>
          </div>
        )}

      </div>

      <form id="expenseform" onSubmit={formik.handleSubmit}>
        <div className="expense_management_form_main_container">
          <p className="expense_management_form_legend">Details</p>

          {/* Expense Head */}
          <div className="expense_management_form_field_block">
            <p className="expense_management_form_label">
              Expense Head <span className="label_required_remark">*</span>
            </p>
            <CustomAutoCompleteDropdown
              isDisabled={isView}
              name="expense_head"
              placeholder="Select expense head"
              options={expenseHeadOptions}
              onChange={(event, newValue) =>
                formik.setFieldValue(
                  "expense_head",
                  newValue ? newValue.value : ""
                )
              }
              onBlur={formik.handleBlur}
              value={
                expenseHeadOptions.find(
                  (opt) => opt.value === formik.values.expense_head
                ) || null
              }
              error={
                formik.touched.expense_head &&
                Boolean(formik.errors.expense_head)
              }
              helperText={
                formik.touched.expense_head && formik.errors.expense_head
              }
            />
          </div>

          {/* Amount Field */}
          <div className="expense_management_form_field_block">
            <p className="expense_management_form_label">
              Amount <span className="label_required_remark">*</span>
            </p>
            <CustomTextField
              isDisabled={isView}
              type="number"
              name="amount"
              placeholder="Enter amount"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.amount}
              error={
                formik.touched.amount && Boolean(formik.errors.amount)
              }
              helperText={formik.touched.amount && formik.errors.amount}
              inputProps={{ inputProps: { min: 0, step: ".01" } }}
            />
          </div>

          {/* Remark Field */}
          <div className="expense_management_form_field_block">
            <p className="expense_management_form_label">
              Remark
            </p>
            <CustomTextArea
              isDisabled={isView}
              rows={4}
              name="remark"
              placeholder="Enter a remark"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.remark}
              error={formik.touched.remark && Boolean(formik.errors.remark)}
              helperText={formik.touched.remark && formik.errors.remark}
            />
          </div>

        </div>

        <div className="expense_management_form_main_container">
          <p className="expense_management_form_legend">Attachment</p>
          {/* Attachment Upload */}
          <div className="expense_management_form_field_block">
            {!isView && (
              <input
                type="file"
                multiple
                accept=".jpg,.jpeg,.png,.gif,.pdf"
                onChange={handleFileChange}
                className="expense_management_form_file_input"
              />
            )}


            {attachments.length > 0 ? (
              <div className="expense_management_form_file_list">
                {attachments.map((file, index) => (
                  <div key={index} className="expense_management_form_file_item">
                    <span className="expense_management_form_file_name"
                      onClick={() => {
                        if (file?.document_url) {
                          // Case 1: File from backend (has URL)
                          const link = document.createElement("a");
                          link.href = file.document_url;
                          link.download = file?.document_name || "expense_file.png";
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        } else if (file instanceof File) {
                          // Case 2: Local file just uploaded (no URL yet)
                          const url = URL.createObjectURL(file);
                          const link = document.createElement("a");
                          link.href = url;
                          link.target = `_blank`;
                          link.download = file.name;
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                          URL.revokeObjectURL(url);
                        }
                      }}
                    >
                      {file.name || file?.document_name}
                    </span>
                    {!isView && (
                      <button
                        type="button"
                        className="expense_management_form_file_remove_btn"
                        onClick={() => handleRemoveFile(index, file?.expense_history_id)}
                      >
                        ✕
                      </button>
                    )}

                  </div>
                ))}
              </div>
            ) : <p className="expense_management_form_file_name">No files attached</p>}
          </div>
        </div>

      </form>
    </div>
  );
}

export default ExpenseManagementForm;
